let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("izi70")).then(() => parcelRequire('9AYOJ'));